import React, { useState, Fragment } from 'react';
import newLeaseModalStyles from '../../../stylesheets/management_site/newLeaseModal.module.scss';
import leaseDetailsFormStyles from '../../../stylesheets/management_site/leaseDetailsForm.module.scss';
import classNames from 'classnames';

const DocumentTemplatesSection = ({
  documentTemplates = [],
  initialSelectedTemplates = [],
  tenantTermOverride = 'Tenant',
  reinstate = false,
}) => {
  const [selectedTemplates, setSelectedTemplates] = useState(
    new Set(initialSelectedTemplates)
  );
  const [isExpanded, setIsExpanded] = useState(false);

  const handleTemplateChange = (templateId, checked) => {
    setSelectedTemplates((prev) => {
      const newSet = new Set(prev);
      if (checked) {
        newSet.add(templateId);
      } else {
        newSet.delete(templateId);
      }
      return newSet;
    });
  };

  const renderDynamicFields = (template) => {
    const dynamicFields =
      template.document_fields?.filter((field) =>
        field.attribute_name?.startsWith('dynamic.')
      ) || [];

    const dynamicHtmlFields = template.dynamic_html_fields || [];

    if (dynamicFields.length === 0 && dynamicHtmlFields.length === 0) {
      return (
        <div
          className={classNames(
            'pm-flex-col',
            newLeaseModalStyles.dynamicField
          )}
        ></div>
      );
    }

    return (
      <div
        className={classNames(
          'pm-flex-col-66',
          newLeaseModalStyles.dynamicField
        )}
      >
        <p className="dynamic-fields-header">
          Dynamic Fields for {template.name}
        </p>
        <div
          className="pm-flex pm-flex-2 dynamic_fields"
          id={`dynamic_fields_${template.id}`}
        >
          {dynamicFields.map((field, index) => (
            <div key={index} className="pm-flex-col">
              <div
                className="mdc-text-field pm-margin-none"
                data-mdc-auto-init="MDCTextField"
              >
                <label className="mdc-floating-label">
                  {field.dynamic_label_name}
                </label>
                <input
                  type="text"
                  name={`lease[document_templates][${template.id}][document_fields][${field.id}][value]`}
                  id={`lease_document_templates_${template.id}_document_fields_${field.id}_value`}
                  className="mdc-text-field__input"
                  defaultValue=""
                />
              </div>
            </div>
          ))}
          {dynamicHtmlFields.map((field, index) => (
            <div key={`html-${index}`} className="pm-flex-col">
              <div
                className="mdc-text-field pm-margin-none"
                data-mdc-auto-init="MDCTextField"
              >
                <label className="mdc-floating-label">{field.name}</label>
                <input
                  type="text"
                  name={`lease[document_templates][${template.id}][dynamic_html_fields][${index}][value]`}
                  id={`lease_document_templates_${template.id}_dynamic_html_fields_${index}_value`}
                  className="mdc-text-field__input"
                  defaultValue=""
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (reinstate || documentTemplates.length === 0) {
    return null;
  }

  return (
    <div className={newLeaseModalStyles.newLeaseModalSection}>
      <div
        className={classNames(
          newLeaseModalStyles.sectionHeader,
          leaseDetailsFormStyles.expandableHeader
        )}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h3 className={newLeaseModalStyles.sectionTitle}>
          <span
            className={classNames(leaseDetailsFormStyles.expandIcon, {
              [leaseDetailsFormStyles.closed]: !isExpanded,
              [leaseDetailsFormStyles.open]: isExpanded,
            })}
          >
            ❯
          </span>
          Documents to Send to {tenantTermOverride}s Now
        </h3>
      </div>
      {isExpanded && (
        <div className={newLeaseModalStyles.sectionContent}>
          <div
            id="lease-tenant-document-checkboxes"
            className="pm-flex pm-flex-3"
          >
            {documentTemplates.map((template) => (
              <Fragment key={template.id}>
                <div
                  className={classNames(
                    'pm-flex-col',
                    newLeaseModalStyles.noMarginBottom
                  )}
                >
                  <div
                    className={classNames(
                      'mdc-form-field',
                      newLeaseModalStyles.formField
                    )}
                  >
                    <div
                      id="mdc-js-checkbox"
                      className="mdc-checkbox"
                      data-mdc-auto-init="MDCCheckbox"
                    >
                      <input
                        type="checkbox"
                        name="lease[document_template_ids][]"
                        id={template.id}
                        className="mdc-checkbox__native-control"
                        value={template.id}
                        defaultChecked={selectedTemplates.has(template.id)}
                        onChange={(e) =>
                          handleTemplateChange(template.id, e.target.checked)
                        }
                      />
                      <div className="mdc-checkbox__background">
                        <svg
                          className="mdc-checkbox__checkmark"
                          viewBox="0 0 24 24"
                        >
                          <path
                            className="mdc-checkbox__checkmark-path"
                            fill="none"
                            stroke="white"
                            d="M1.73,12.91 8.1,19.28 22.79,4.59"
                          />
                        </svg>
                        <div className="mdc-checkbox__mixedmark"></div>
                      </div>
                    </div>
                    <label htmlFor={template.id} id="my-checkbox-label">
                      {template.name}
                    </label>
                  </div>
                </div>
                {renderDynamicFields(template)}
                <br />
              </Fragment>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentTemplatesSection;
